import { sortArrayObject } from 'GenericForms/Helper';
import env from '../../environment/env'

interface FormValuesDebugType {
    values: any[]
}

/**
 * Debug Tool for the formik values or any other object to be checked while development 
 * @param values 
 * @returns 
 */
function FormValuesDebug({ values }: FormValuesDebugType) {
    return (
        <div>
            {env?.debugSetting &&
                values.map((object: any, index: number) => {
                    return (<pre key={index}>
                        {
                            JSON.stringify(sortArrayObject(object), null, 4)
                        }
                    </pre>)
                })
            }
        </div>
    )
}

export default FormValuesDebug;